import { colors } from '@cobliteam/ui/theme';
import { css } from 'emotion';

const icon = css`
  width: 16px;
  height: 16px;
  padding: 8px;
  box-sizing: content-box;
  border-radius: 3px;
  flex-shrink: 0;
`;

const iconDefault = css`
  ${icon}
  background-color: ${colors.gray.a2};
  color: ${colors.gray[10]};
`;

const iconClient = css`
  svg {
    ${icon}
    background-color: ${colors.success.a2};
    color: ${colors.success[9]};
  }
`;

const iconBase = css`
  svg {
    ${icon}
    background-color: ${colors.primary.a2};
    color: ${colors.primary[9]};
  }
`;

const iconOther = css`
  svg {
    ${icon}
    background-color: ${colors.warning.a2};
    color: ${colors.warning[9]};
  }
`;

const iconSupply = css`
  svg {
    ${icon}
    background-color: ${colors.accessory.purple.a2};
    color: ${colors.accessory.purple[9]};
  }
`;

const iconMaintenance = css`
  svg {
    ${icon}
    background-color: ${colors.accessory.tomato.a2};
    color: ${colors.accessory.tomato[9]};
  }
`;

const iconHeadquarter = css`
  svg {
    ${icon}
    background-color: ${colors.accessory.sky.a2};
    color: ${colors.accessory.sky[9]};
  }
`;

export default {
  iconDefault,
  iconClient,
  iconBase,
  iconOther,
  iconSupply,
  iconMaintenance,
  iconHeadquarter,
};
